export const TRANSACTION_STATUS =
    {
        PENDING: 0,
        CANCELED: 1,
        SHIPPING: 2,
        COMPLETED: 3,
        ERROR: 4

    }
